
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Report } from "@/lib/model/exam/candidate";

@Component
export default class Login extends Vue {
  @Prop({ default: "" }) connectCode!: string;
  @Prop({ default: "" }) reportCertiCodeCacheExamId!: string;

  code = "";
  submitting = false;
  showError = false;

  async submit() {
    if (this.submitting) return;
    this.submitting = true;
    this.showError = false;

    const pass = await this.checkPassword();
    if (pass) {
      const ttl = 24 * 60 * 60 * 1000; // 24小时的毫秒数
      this.setStorageWithExpiry(
        this.reportCertiCodeCacheExamId,
        this.code,
        ttl
      );
      this.$emit("login");
    } else {
      this.showError = true;
    }
    this.submitting = false;
  }

  async checkLocalstroage() {
    // 检查本地存储中是否有提取码
    const code = this.getStorageWithExpiry(this.reportCertiCodeCacheExamId);
    if (code) {
      return await this.checkPassword(code);
    } else {
      return false;
    }
  }
  async checkPassword(pwd = this.code): Promise<boolean> {
    //
    return await Report.checkPassword({
      reportCertiCode: pwd,
      connectCode: this.connectCode
    }).then(res => {
      return res.success;
    });
  }

  setStorageWithExpiry(key: string, value: string, ttl: number) {
    const now = new Date();
    // `item` 是一个对象，其中包含了原始值和过期时间
    const item = {
      value: value,
      expiry: now.getTime() + ttl
    };
    localStorage.setItem(key, JSON.stringify(item));
  }
  getStorageWithExpiry(key: string) {
    const itemStr = localStorage.getItem(key);

    // 如果 `item` 不存在，返回 null
    if (!itemStr) {
      return null;
    }

    const item = JSON.parse(itemStr);
    const now = new Date();

    // 比较当前时间和过期时间
    if (now.getTime() > item.expiry) {
      // 如果过期了，删除该项并返回 null
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  }
}
